// extracted by css-extract-rspack-plugin
export default {"root":"_1szuw_-6X_Hu0CN-x7hsSJ"};